module.exports = __webpack_public_path__ + "static/media/schermata_Bilapp_1.283e9244.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SchermateBilapp/schermata_Bilapp_1.jpg
// module id = 663
// module chunks = 0